require('../shared/application').setup();
const form = require('../shared/form');
const $ = require('jquery');

form.bootstrap();

// bold nav item
if ($.inArray('about', window.location.pathname.split('/'))) {
  document.querySelector('.Nav-link--about').classList.add('is-bold');
}

// Functions for checking if the variable is unspecified
function cleanString(string) {
  if (string) {
    return string.replace(/\s+/ig, '');
  } else {
    return 'Uncategorized';
  }
}

function nullCheck(string) {
  if (!string) {
    return 'Uncategorized';
  } else {
    return string;
  }
}

function createJobs(_data) {

  _data.forEach((item) => {
    const team = nullCheck(item.title);
    const teamCleanString = cleanString(team);

    $('.JoinSection-jobs').append(
      '<div class="JoinSection-jobs-team col-xs-12 col-sm-6 ' + teamCleanString + '">' +
        '<h3>' + team + '</h3>' +
        '<ul class="JoinSection-jobs-list">' +
        '</ul>' +
      '</div>'
      );
  });

  _data.forEach((item) => {
    item.postings.forEach((posting) => {
      const title = posting.text;

      const location = nullCheck(posting.categories.location);
      const commitment = nullCheck(posting.categories.commitment);
      const team = nullCheck(posting.categories.team);
      const teamCleanString = cleanString(team);
      const link = posting.hostedUrl;

      $('.' + teamCleanString).find('.JoinSection-jobs-list').append(
        '<li><a href="' + link + '" class="JoinSection-job-title" target="_blank">' +
        title +
        '</a>' +
        '<span class="JoinSection-job-meta">' +
        location + ', ' + team + ', ' + commitment +
        '</span></li>'
      );
    });
  });
}

// Fetching job postings from Lever's postings API
$.ajax({
  dataType: 'json',
  url: 'https://api.lever.co/v0/postings/claralabs?group=team&mode=json',
  success: createJobs,
});
